export const zIndex = {
  header: 10,
  mobileNav: 12,
  mobileNavButtons: 13,
  portal: 20,
  pageTransitionMask: 30,
}
